import { p } from "./_helpers";

const numerique = {
 slug: "numerique",
 path: "/secteurs/numerique",
 hero: {
 image: "/photos/sector-numerique-hero.jpg",
 alt: p("Numérique et technologie en Afrique de l'Ouest", "Digital and technology in West Africa", "Digital e tecnologia na África Ocidental"),
 breadcrumb: p("Numérique", "Digital", "Digital"),
 title: p("Investir dans le numérique.", "Investing in digital.", "Investir no digital."),
 subtitle: p(
 "Mobile money, plateformes e-commerce, cloud, cybersécurité, fintech, IA appliquée : un territoire encore neuf pour une génération connectée.",
 "Mobile money, e-commerce platforms, cloud, cybersecurity, fintech, applied AI: a still-fresh territory for a connected generation.",
 "Mobile money, plataformas de e-commerce, cloud, cibersegurança, fintech, IA aplicada: um território ainda novo para uma geração conectada."
 ),
 },
 seo: {
 title: p(
 "Investir dans le numérique en Guinée-Bissau | NANDA SÁ",
 "Investing in digital in Guinea-Bissau | NANDA SÁ",
 "Investir no digital na Guiné-Bissau | NANDA SÁ"
 ),
 description: p(
 "Mobile money, fintech, e-commerce, cloud, cybersécurité, IA : le panorama numérique de la Guinée-Bissau. Chiffres, opportunités et passerelles NANDA SÁ.",
 "Mobile money, fintech, e-commerce, cloud, cybersecurity, AI: the digital panorama of Guinea-Bissau. Figures, opportunities and NANDA SÁ pathways.",
 "Mobile money, fintech, e-commerce, cloud, cibersegurança, IA: o panorama digital da Guiné-Bissau. Dados, oportunidades e pontes NANDA SÁ."
 ),
 keywords: "numérique Guinée-Bissau, fintech Guinée-Bissau, mobile money Afrique de l'Ouest, e-commerce Bissau, cloud CEDEAO, tech startup Afrique",
 },
 presentation: {
 title: p("Une génération connectée, un territoire neuf.", "A connected generation, a fresh territory.", "Uma geração conectada, um território novo."),
 paragraphs: p(
 [
 "Le taux de pénétration mobile en Guinée-Bissau dépasse aujourd'hui 90 %, et près d'un adulte sur deux utilise le mobile money. La Guinée-Bissau, connectée au réseaux régionaux CEDEAO, bénéficie d'une infrastructure télécom parmi les meilleures d'Afrique de l'Ouest. Cette base ouvre un champ de possibles gigantesque : paiements, e-commerce, ed-tech, agri-tech, health-tech, tourisme, administration.",
 "Peu d'acteurs technologiques structurés opèrent aujourd'hui sur ce marché combiné. C'est un terrain où la première génération d'investisseurs sérieux construit des positions difficiles à contester par la suite.",
 ],
 [
 "Mobile penetration in Guinea-Bissau today exceeds 90%, and nearly one adult in two uses mobile money. Guinée-Bissau, connected to the Bissau-Guinean network, benefits from telecom infrastructure among the best in West Africa. This base opens a gigantic field of possibilities: payments, e-commerce, ed-tech, agri-tech, health-tech, tourism, administration.",
 "Few structured tech players operate on this combined market today. It is a ground where the first generation of serious investors builds positions that will be difficult to contest.",
 ],
 [
 "A taxa de penetração móvel na Guiné-Bissau ultrapassa hoje os 90 %, e cerca de um em cada dois adultos usa mobile money. A Guiné-Bissau beneficia de uma infra-estrutura de telecomunicações em modernização e conectada aos principais corredores regionais. Esta base abre um campo de possibilidades gigantesco: pagamentos, e-commerce, ed-tech, agri-tech, health-tech, turismo, administração.",
 "Poucos actores tecnológicos estruturados operam hoje neste mercado combinado. É um terreno onde a primeira geração de investidores sérios constrói posições difíceis de contestar posteriormente.",
 ]
 ),
 },
 kpis: {
 title: p("Chiffres clés du numérique", "Digital key figures", "Dados-chave do digital"),
 items: [
 { n: "90 %+", l: p("Pénétration mobile", "Mobile penetration", "Penetração móvel"), d: p("Marché mobile-first structurel.", "Structurally mobile-first market.", "Mercado estruturalmente mobile-first.") },
 { n: "50 %", l: p("Adultes en mobile money", "Adults using mobile money", "Adultos com mobile money"), d: p("Orange Money, Wave, Djamo — usages massifs.", "Orange Money, Wave, Djamo — mass usage.", "Orange Money, Wave, Djamo — utilizações em massa.") },
 { n: "4G", l: p("Couverture urbaine", "Urban coverage", "Cobertura urbana"), d: p("Bissau, Bafatá bien couverts.", "Bissau, Bafatá well covered.", "Bissau, Bafatá bem cobertos.") },
 { n: "€ 1,2 Md", l: p("Éco. numérique CEDEAO 2030", "ECOWAS digital econ. 2030", "Econ. digital CEDEAO 2030"), d: p("Croissance projetée à deux chiffres.", "Double-digit projected growth.", "Crescimento projectado a dois dígitos.") },
 { n: "OMVG", l: p("Fibre transfrontalière", "Cross-border fibre", "Fibra transfronteiriça"), d: p("Backbone régional Guinée-Bissau · depuis 2023.", "Regional backbone Guinea-Bissau · since 2023.", "Backbone regional Guiné-Bissau · desde 2023.") },
 { n: "Rare", l: p("Cloud local souverain", "Sovereign local cloud", "Cloud local soberano"), d: p("Marché B2B et administratif à créer.", "B2B and administrative market to create.", "Mercado B2B e administrativo a criar.") },
 ],
 sources: p(
 "Sources : GSMA, ANATEC Guinée-Bissau, Banque mondiale, données 2023-2025.",
 "Sources: GSMA, ARTP ANATEC Guinea-Bissau, World Bank, data 2023-2025.",
 "Fontes: GSMA, ARTP ANATEC Guiné-Bissau, Banco Mundial, dados 2023-2025."
 ),
 },
 opportunites: {
 title: p("Segments d'investissement prioritaires", "Priority investment segments", "Segmentos de investimento prioritários"),
 intro: p(
 "Quatre segments à forte scalabilité, avec des business models régionaux éprouvés.",
 "Four highly scalable segments with proven regional business models.",
 "Quatro segmentos de forte escalabilidade com modelos de negócio regionais comprovados."
 ),
 segments: [
 { h3: p("1. Fintech & paiements marchands", "1. Fintech & merchant payments", "1. Fintech e pagamentos comerciais"),
 p: p("Acquisition marchande, wallets, crédits courts. Ticket : 200 000 à 800 000 €.", "Merchant acquisition, wallets, short credit. Ticket: €200k to €800k.", "Aquisição comercial, wallets, créditos curtos. Ticket: 200 000 a 800 000 €.") },
 { h3: p("2. E-commerce & marketplaces transfrontalières", "2. E-commerce & cross-border marketplaces", "2. E-commerce e marketplaces transfronteiriços"),
 p: p("Marché combiné 3 M+ habitants, diaspora. Ticket : 100 000 à 400 000 €.", "Combined market 3M+ people, diaspora. Ticket: €100k to €400k.", "Mercado combinado 3 M+ habitantes, diáspora. Ticket: 100 000 a 400 000 €.") },
 { h3: p("3. Services numériques pro (SaaS métier)", "3. Business digital services (vertical SaaS)", "3. Serviços digitais profissionais (SaaS vertical)"),
 p: p("Agri-tech, logi-tech, tourisme, éducation. Ticket : 60 000 à 250 000 €.", "Agri-tech, logi-tech, tourism, education. Ticket: €60k to €250k.", "Agri-tech, logi-tech, turismo, educação. Ticket: 60 000 a 250 000 €.") },
 { h3: p("4. Cybersécurité & cloud souverain", "4. Cybersecurity & sovereign cloud", "4. Cibersegurança e cloud soberano"),
 p: p("Marché B2B et institutionnel encore neuf. Ticket : 300 000 à 1 M€.", "Still-fresh B2B and institutional market. Ticket: €300k to €1M.", "Mercado B2B e institucional ainda novo. Ticket: 300 000 a 1 M€.") },
 ],
 },
 defis: {
 title: p("Les défis à anticiper", "Challenges to anticipate", "Desafios a antecipar"),
 intro: p(
 "Le numérique récompense la vitesse d'exécution et la proximité usager.",
 "Digital rewards execution speed and user proximity.",
 "O digital recompensa a velocidade de execução e a proximidade ao utilizador."
 ),
 items: p(
 [
 "Cadre réglementaire fintech encore mouvant — veille indispensable.",
 "Recrutement de développeurs seniors — partenariats académiques et diaspora tech.",
 "Éducation à la cybersécurité des usagers finaux.",
 "Fragmentation linguistique (PT / FR / EN) à intégrer dès le produit.",
 ],
 [
 "Still-shifting fintech regulatory framework — continuous monitoring indispensable.",
 "Recruiting senior developers — academic partnerships and tech diaspora.",
 "User cybersecurity education.",
 "Language fragmentation (PT / FR / EN) to integrate from product design.",
 ],
 [
 "Enquadramento regulamentar fintech ainda em mudança — monitorização indispensável.",
 "Recrutamento de programadores sénior — parcerias académicas e diáspora tech.",
 "Educação à cibersegurança dos utilizadores finais.",
 "Fragmentação linguística (PT / FR / EN) a integrar desde a concepção do produto.",
 ]
 ),
 closing: p(
 "Ces défis sont ceux d'un secteur qui récompense la clairvoyance. Les leaders régionaux de 2030 se positionnent dès aujourd'hui.",
 "These challenges are those of a sector that rewards clairvoyance. Regional leaders of 2030 position themselves today.",
 "Estes desafios são os de um sector que recompensa a clarividência. Os líderes regionais de 2030 posicionam-se desde já."
 ),
 },
 pourquoi: {
 title: p("La Maison qui parle aux entrepreneurs.", "The House that speaks to entrepreneurs.", "A Casa que fala aos empreendedores."),
 paragraphs: p(
 [
 "NANDA SÁ opère avec un réseau de développeurs, designers et product managers en Guinée-Bissau et à Paris. Nous savons interfacer entrepreneurs tech, financements, régulateurs et clients finaux. Nous voyons dans le numérique un accélérateur des filières que nous portons déjà.",
 ],
 [
 "NANDA SÁ operates with a network of developers, designers and product managers in Guinea-Bissau and Paris. We know how to interface tech entrepreneurs, financing, regulators and end clients. We see digital as an accelerator of the value chains we already carry.",
 ],
 [
 "A NANDA SÁ opera com uma rede de programadores, designers e product managers na Guiné-Bissau e em Paris. Sabemos interligar empreendedores tech, financiamentos, reguladores e clientes finais. Vemos no digital um acelerador das fileiras que já sustentamos.",
 ]
 ),
 bullets: p(
 [
 "Étude de marché produit et régulation",
 "Recrutement tech local et diaspora",
 "Partenariats institutionnels et bancaires",
 "Structuration juridique et fiscale",
 ],
 [
 "Product market and regulation study",
 "Local and diaspora tech recruitment",
 "Institutional and banking partnerships",
 "Legal and tax structuring",
 ],
 [
 "Estudo de mercado do produto e regulação",
 "Recrutamento tech local e diáspora",
 "Parcerias institucionais e bancárias",
 "Estruturação jurídica e fiscal",
 ]
 ),
 },
 download: {
 title: p("Télécharger la note « Numérique · Guinée-Bissau ».", "Download the brief « Digital · Guinea-Bissau ».", "Descarregar a nota « Digital · Guiné-Bissau »."),
 body: p(
 "Note préparée par NANDA SÁ : chiffres clés, segments à fort potentiel, cadre réglementaire, contacts utiles.",
 "Brief prepared by NANDA SÁ: key figures, high-potential segments, regulatory framework, useful contacts.",
 "Nota preparada pela NANDA SÁ: dados-chave, segmentos de forte potencial, enquadramento regulamentar, contactos úteis."
 ),
 pdfUrl: "/pdf/nanda-sa-note-numerique.pdf",
 pdfFilename: "nanda-sa-note-numerique.pdf",
 mailSubject: p("Téléchargement de la note « Numérique »", "Download of the brief « Digital »", "Descarga da nota « Digital »"),
 mailBody: p(
 "Bonjour, je souhaite recevoir la note « Numérique · Guinée-Bissau ».",
 "Hello, I would like to receive the brief « Digital · Guinea-Bissau ».",
 "Olá, gostaria de receber a nota « Digital · Guiné-Bissau »."
 ),
 },
 contact: {
 title: p("Parlons de votre projet numérique.", "Let's talk about your digital project.", "Falemos do seu projecto digital."),
 body: p(
 "Startup, fintech, e-commerçant, éditeur SaaS, investisseur, diaspora tech : décrivez votre intention, nous répondons personnellement.",
 "Startup, fintech, e-merchant, SaaS publisher, investor, tech diaspora: describe your intention, we respond personally.",
 "Startup, fintech, e-comerciante, editor SaaS, investidor, diáspora tech: descreva a sua intenção, respondemos pessoalmente."
 ),
 quote: p(
 "Le numérique ne remplace pas le terrain. Il l'amplifie, à condition qu'on connaisse le terrain.",
 "Digital does not replace the ground. It amplifies it, provided you know the ground.",
 "O digital não substitui o terreno. Amplia-o, desde que se conheça o terreno."
 ),
 subject: p("Investir dans le numérique en Guinée-Bissau", "Invest in digital in Guinea-Bissau", "Investir no digital na Guiné-Bissau"),
 },
 ctas: ["Conseil"],
};

export default numerique;
